<template>
  <div
    @click="newPage(link)"
    class="h-[83px] w-[66px] flex flex-col items-center justify-center"
  >
    <a href="" class="grid items-center justify-items-center">
      <div
        :class="bodyClasses"
        class="
          bg-white
          rounded-full
          hover:bg-gray-300
          h-[58px]
          w-[58px]
          flex
          justify-center
          items-center
          mb-1.5
        "
      >
        <slot></slot>
      </div>
      <span :class="textClasses" class="text-[14px] text-white mx-auto block text-center">{{
        description
      }}</span>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    description: String,
    textClasses: String,
    bodyClasses: String,
    link: String,
  },

  methods: {
    newPage(link) {
      window.open(link, "_blank");
    },
  },
};
</script>
